import { ChangeDetectionStrategy, Component, Input, Output, inject } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { E2eDirective, MUSCLE_LABELS } from '@fitness-tracker/shared/utils';

@Component({
  selector: 'ft-muscle-multi-select',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    E2eDirective,
    MatOptionModule,
    TitleCasePipe,
  ],
  template: `<form class="filters" [formGroup]="workoutFilters">
      <mat-form-field class="filters__item" appearance="outline">
        <mat-select
          formControlName="targetMuscles"
          multiple
          placeholder="Select target muscles"
          ftE2e="targetMuscles"
          >
          @for (muscle of muscleList; track muscle) {
            <mat-option
              [value]="muscle"
              ftE2e="muscle"
              >{{ muscleLabels[muscle] | titlecase }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </form>`,
  styles: [
    `
      .filters {
        display: flex;
        justify-content: center;
        flex: 1;

        &__item {
          flex: 1;
        }
      }

      @media screen and (min-width: 600px) {
        .filters {
          justify-content: flex-start;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MuscleMultiSelectComponent {
  private readonly fb = inject(FormBuilder);
  protected readonly muscleLabels = MUSCLE_LABELS;

  @Input() public muscleList: string[] = [];
  @Input()
  public set initialTargetMuscles(targetMuscles: string[]) {
    this.workoutFilters.patchValue({ targetMuscles }, { emitEvent: false });
  }

  public readonly workoutFilters = this.fb.group<{
    targetMuscles: null | string[];
  }>({
    targetMuscles: null,
  });

  @Output()
  public readonly targetMusclesFiltersChanges = this.targetMuscles.valueChanges;

  get targetMuscles(): AbstractControl {
    return this.workoutFilters.get('targetMuscles') as AbstractControl;
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
